import React from "react";
import { NavbarBorrowSystem } from "../../../components/share/NavbarBorrowSystem";
import { HeadTitle } from "../../../components/share/HeadTitle";
import { FormTrainComponent } from "../../../components/borrowSystem/BorrowForm/FormTrainComponent";
import { Footer } from "../../../components/share/Footer";

export function FormTrainContainer() {
  const titleName =
    "รายละเอียดการขอกู้ยืมเงินกองทุนพัฒนาฝีมือแรงงานเพื่อดำเนินการฝึกอบรม";

  return (
    <div className="page-container bg-landing">
      <NavbarBorrowSystem />
      <HeadTitle title={titleName} />
      <FormTrainComponent />
      <Footer />
    </div>
  );
}
